/**
 * Shared input mask utility for landing page forms.
 *
 * Usage:
 *   applyInputMask(value, mask)
 *   - value: the raw input string
 *   - mask: format string where '0' is a digit placeholder and other chars are literals
 *
 * Example:
 *   applyInputMask('11987654321', '(00) 00000-0000') => '(11) 98765-4321'
 *
 * Loaded by landing.liquid for use in landing-form.js and landing-modern.js.
 */
function applyInputMask(value, mask) {
  var cleanValue = String(value || '').replace(/\D/g, '');
  var result = '';
  var valueIndex = 0;

  for (var i = 0; i < mask.length && valueIndex < cleanValue.length; i++) {
    if (mask[i] === '0') {
      result += cleanValue[valueIndex];
      valueIndex++;
    } else {
      result += mask[i];
      if (cleanValue[valueIndex] === mask[i]) {
        valueIndex++;
      }
    }
  }

  return result;
}
